document.addEventListener('DOMContentLoaded', () => {
  const generateSvgButton = document.querySelector('#generate-pdf-link');
  const addToCartButton = document.querySelector('button[data-js-product-add-to-cart]');
  const overlay = document.createElement('div');
  overlay.id = 'interaction-blocker';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
  overlay.style.zIndex = '99999';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);
  
  if (generateSvgButton) {
    generateSvgButton.addEventListener('click', async (event) => {
      console.log("Generate SVG button clicked");
      event.preventDefault();
      event.stopPropagation();
      
      const spinner = document.createElement('span');
      spinner.className = 'spinner';
      generateSvgButton.appendChild(spinner);
      generateSvgButton.disabled = true;
      overlay.style.display = 'block';
      
      try {
        // Hole die SKU-Nummer aus dem entsprechenden Element
        const skuElement = document.getElementById('sku');
        const sku = skuElement ? skuElement.textContent.trim() : 'unknown';
        
        // NEU: Hole die ausgewählte Farbe aus der Wunschtext-Konfiguration
        let selectedColorHex = 'unknown';
        let selectedColorLabel = 'unknown';

        // Nimm z.B. die erste Zeile als Referenz für die Folienfarbe
        const firstLineColorSelect = document.querySelector('.line-control .dynamic-select-color');

        if (firstLineColorSelect) {
          const colorInput = firstLineColorSelect.querySelector('.wunschtext-line-color-input');
          if (colorInput && colorInput.value) {
            selectedColorHex = colorInput.value.trim(); // z.B. "#000000"
          }

          const selectedOption = firstLineColorSelect.querySelector('.dynamic-select-option.dynamic-select-selected');
          if (selectedOption && selectedOption.dataset.label) {
            selectedColorLabel = selectedOption.dataset.label.trim(); // z.B. "Schwarz matt"
          }
        }

        // Für Dateinamen lieber das Label, Fallback auf Hex
        const colorForFileNameRaw = selectedColorLabel !== 'unknown' ? selectedColorLabel : selectedColorHex;
        const colorForFileName = colorForFileNameRaw
          ? colorForFileNameRaw.replace(/\s+/g, '-')
          : 'unknown-color';

        // Für den Server schicken wir die Hex-Farbe
        const colorForServer = selectedColorHex;

        // Hole Breite und Höhe aus den Input-Feldern
        const widthInput = document.getElementById('target-width-cm');
        const heightInput = document.getElementById('target-height-cm');
        
        const width = widthInput ? widthInput.value : 'unknown';
        const height = heightInput ? heightInput.value : 'unknown';
        
        // Hole die SVG-Elemente
// Hole die SVG-Elemente
const svgText = document.getElementById('text-preview');
if (!svgText) {
  throw new Error("Text-SVG (#text-preview) not found");
}

const svgMotiv = document.getElementById('svg-path');

// Default: nur Text-SVG serialisieren
let elementToSerialize = svgText;

if (svgMotiv) {
  const SVG_NS = 'http://www.w3.org/2000/svg';

  // Container, in dem beide SVGs sitzen
  const container = document.querySelector('.svg-size') || svgText.parentElement;

  const containerRect = container.getBoundingClientRect();
  const motivRect     = svgMotiv.getBoundingClientRect();
  const textRect      = svgText.getBoundingClientRect();

  // Neues kombiniertes SVG mit exakt der Screen-Grösse des Containers
  const totalWidth  = containerRect.width;
  const totalHeight = containerRect.height;

  const combinedSvg = document.createElementNS(SVG_NS, 'svg');
  combinedSvg.setAttribute('xmlns', SVG_NS);
  combinedSvg.setAttribute('viewBox', `0 0 ${totalWidth} ${totalHeight}`);
  combinedSvg.setAttribute('width', totalWidth);
  combinedSvg.setAttribute('height', totalHeight);

  // Helfer: ein vorhandenes SVG in eine Gruppe klonen und
  //       so skalieren/verschieben, wie es im Browser gerendert wird
  function cloneSvgIntoGroup(srcSvg, rect) {
    const vb = srcSvg.getAttribute('viewBox');
    let scaleX = 1, scaleY = 1;
    let offsetX = rect.left - containerRect.left;
    let offsetY = rect.top  - containerRect.top;

    if (vb) {
      const [vx, vy, vw, vh] = vb.split(/\s+/).map(parseFloat);

      // Verhältnis: viewBox → gerenderte px
      scaleX = rect.width  / vw;
      scaleY = rect.height / vh;

      // viewBox-Origin berücksichtigen
      offsetX -= vx * scaleX;
      offsetY -= vy * scaleY;
    }

    const g = document.createElementNS(SVG_NS, 'g');
    g.setAttribute('transform', `translate(${offsetX},${offsetY}) scale(${scaleX},${scaleY})`);

    Array.from(srcSvg.childNodes).forEach(node => {
      g.appendChild(node.cloneNode(true));
    });

    return g;
  }

  // Motiv & Text so einbauen, wie sie auf dem Screen sitzen
  combinedSvg.appendChild(cloneSvgIntoGroup(svgMotiv, motivRect));
  combinedSvg.appendChild(cloneSvgIntoGroup(svgText,  textRect));

  elementToSerialize = combinedSvg;
}

// Serialisieren (wie gehabt)
const serializer = new XMLSerializer();
const svgString = serializer.serializeToString(elementToSerialize);
const blob = new Blob([svgString], { type: 'image/svg+xml' });




        const fileName = `${sku}_${colorForFileName}_${width}x${height}_${generateRandomId(8)}.svg`;
        
        const pdfUrl = await sendToServer(blob, fileName, sku, colorForServer, width, height);
        if (pdfUrl) {
          setSvgInputValue(pdfUrl);
        }
      } catch (error) {
        console.error('Error generating SVG:', error);
        alert('There was an error generating the SVG. Please try again.');
      } finally {
        spinner.remove();
        generateSvgButton.disabled = false;
        overlay.style.display = 'none';
        if (addToCartButton) {
          addToCartButton.click();
        }
      }
    });
  } else {
    console.error('Generate SVG button not found.');
  }
  
  function generateRandomId(length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  }
  
  async function sendToServer(svgBlob, fileName, sku, color, width, height) {
    const formData = new FormData();
    formData.append('svgFile', svgBlob, fileName);
    formData.append('sku', sku);
    formData.append('color', color); // <-- jetzt Hex-Wert aus dynamic-select
    formData.append('width', width);
    formData.append('height', height);
    
    const response = await fetch('https://design.my-foil.ch/mw-cloud-convert-svg-pdf.php', {
      method: 'POST',
      body: formData,
    }).catch(error => {
      console.error('Network error:', error);
      alert('There was a network error while uploading the SVG. Please try again.');
      return null;
    });
    
    if (response && response.ok) {
      const data = await response.json();
      console.log('Server Response:', data);
      if (data && data.pdf_link) {
        return data.pdf_link;
      } else {
        console.error('PDF URL not found in the server response:', data);
      }
    }
    return null;
  }
  
  function setSvgInputValue(pdfUrl) {
    const svgInput = document.getElementById('pdf_link');
    if (svgInput) {
      svgInput.value = pdfUrl;
    } else {
      console.error('PDF input field not found');
    }
  }
});
